import { render, staticRenderFns } from "./vertifyList.vue?vue&type=template&id=182afd14&scoped=true&"
import script from "./vertifyList.vue?vue&type=script&lang=js&"
export * from "./vertifyList.vue?vue&type=script&lang=js&"
import style0 from "./vertifyList.vue?vue&type=style&index=0&id=182afd14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182afd14",
  null
  
)

export default component.exports